import { Json, Schema, ValidationResult, validateObject } from "./validation.ts";

export const BASEURL = 'https://esrapi.fe-bis.de/api/geocalc';
export const APIUSER = "febis_geo3d";//"skp";
export const APIPASSWORD = "L6g$ds71Us%5";//"tZd7$kdHb!r9";
export type TRequestMethod = "GET" | "POST" | "PUT" | "DELETE";
interface RestResponse {
    error:number; // 0 = no error, 1 = error
    error_code:number;
    error_text:string;
    item:object;
}

export class Request<Res> {
    method: TRequestMethod = "GET";
    responseSchema : Schema = {};

    constructor (){}
    
    route() : string{
        return '';
    }

    json() : string{
        const data = JSON.parse(JSON.stringify(this));
        Object.keys(data).forEach(key => {
            if (data[key] === undefined) {
                delete data[key];
            }
        });
        delete data['sessionToken'];
        delete data['method'];
        delete data['responseSchema'];
        return JSON.stringify(data)
    }

    validate (data: Json): ValidationResult {
        return validateObject(data, this.responseSchema);
    }

    headers() : Record<string | number | symbol, never>{
        return {};
    }

    async request() : Promise<Res>{
        const route = this.route();
        const method = this.method;
        const headers = {
           ...this.headers(), "X-Embarcadero-App-Secret" : "CBC!ApiEsrCal2025",
        };
        try{
          const response = await fetch(route, {
                method: method,
                headers,
                ...(method == 'GET' ? {} : {body: this.json()}),
              });
              
            const json : Json = await response.json();
            const error = json as unknown as {error: string, description: string};

            if ("error" in error && error["error"] != undefined && error["error"] != "") {
                throw new Error(error["error"] + ' ' + route + ' ' + error["description"]);
            }
        
            if (!this.validate(json)) {
                throw new Error(" maleformed data: " + ' ' + route + ' ' + JSON.stringify(json));
            }
      
            return json as Res;
        }catch(e){
            throw e;
        }
      }
}